import { BadgeProps } from '@/dc-shared-web/src/components/shadcn/badge'

export const statusMap: Record<
  string,
  { text: string; color: BadgeProps['color'] }
> = {
  'In Progress': {
    text: 'Processing',
    color: 'green',
  },
  'in-progress': {
    text: 'Processing',
    color: 'green',
  },
  exporting: {
    text: 'Exporting',
    color: 'blue',
  },
  error: {
    text: 'Error',
    color: 'red',
  },
  completed: {
    text: 'Completed',
    color: 'green',
  },
}
